/**
 * @generated SignedSource<<4d815b42143235c09aef72bb58bad3e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateExpenseNatureInputObject = {
  color?: string | null | undefined;
  expenseNatureId: string;
  name?: string | null | undefined;
};
export type naturePivotPage_UpdateMutation$variables = {
  input: UpdateExpenseNatureInputObject;
};
export type naturePivotPage_UpdateMutation$data = {
  readonly updateExpenseNature: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly expenseNature: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
};
export type naturePivotPage_UpdateMutation = {
  response: naturePivotPage_UpdateMutation$data;
  variables: naturePivotPage_UpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNature",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "naturePivotPage_UpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateExpenseNatureMutationPayload",
        "kind": "LinkedField",
        "name": "updateExpenseNature",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "naturePivotPage_UpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateExpenseNatureMutationPayload",
        "kind": "LinkedField",
        "name": "updateExpenseNature",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "54207cb19d3ed7c0024246713f6896b5",
    "id": null,
    "metadata": {},
    "name": "naturePivotPage_UpdateMutation",
    "operationKind": "mutation",
    "text": "mutation naturePivotPage_UpdateMutation(\n  $input: UpdateExpenseNatureInputObject!\n) {\n  updateExpenseNature(input: $input) {\n    expenseNature {\n      id\n      name\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "078aabe38c212bc68f4d245af2f6abe3";

export default node;
